module.exports = __webpack_public_path__ + "img/2019-01-25.0d2fd531.jpg";